module.exports = function() {
  return new Worker(__webpack_public_path__ + "cb2f53b55a8491b24699.worker.js");
};